import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Logs from './pages/Logs';
import GroupLogs from './pages/GroupLogs';
import ChannelLogs from './pages/ChannelLogs';
import PlayerLogs from './pages/PlayerLogs';
import Statistics from './pages/Statistics';
import Economy from './pages/Economy';
import FiveMPlayer from './pages/FiveMPlayer';
import PlayerList from './pages/PlayerList';
import Alerts from './pages/Alerts';
import JobAbuseAlerts from './pages/JobAbuseAlerts';
import AuthCallback from './pages/AuthCallback';
import Unauthorized from './pages/Unauthorized';

// Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Context
import { useAuth } from './context/AuthContext';

function App() {
    const { loading } = useAuth();

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="loading-spinner"></div>
                <p>Đang tải...</p>
            </div>
        );
    }

    return (
        <>
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/unauthorized" element={<Unauthorized />} />

                {/* Protected Routes */}
                <Route path="/" element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }>
                    <Route index element={<Dashboard />} />
                    <Route path="logs" element={<Logs />} />
                    <Route path="group/:groupKey" element={<GroupLogs />} />
                    <Route path="channel/:channelKey" element={<ChannelLogs />} />
                    <Route path="player/:steamId" element={<PlayerLogs />} />
                    <Route path="statistics" element={<Statistics />} />
                    <Route path="economy" element={<Economy />} />
                    <Route path="fivem-player/:citizenId" element={<FiveMPlayer />} />
                    <Route path="players" element={<PlayerList />} />
                    <Route path="alerts" element={<Alerts />} />
                    <Route path="job-abuse" element={<JobAbuseAlerts />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                theme="dark"
            />
        </>
    );
}

export default App;
